module.exports = __webpack_public_path__ + "img/logo_kumparan.e7af1b17.png";